import { PostOrderFeedbackState } from './types'

export const initialPostOrderFeedbackState: PostOrderFeedbackState = {
  allowPostOrderFeedbackEmail: false,
  isFormSubmitting: false,
}
